<!-- Нейтральный маркер отсутствия сигнала. -->
<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    focusable="false"
  >
    <circle cx="12" cy="12" r="7" :stroke="stroke" stroke-width="2" />
    <path d="M7 7l10 10" :stroke="stroke" stroke-width="2" stroke-linecap="round" />
  </svg>
</template>

<script>
export default {
  name: "StatusOfflineIcon",

  props: {
    size: {
      type: [Number, String],
      default: 20,
    },
    stroke: {
      type: String,
      default: "currentColor",
    },
  },
};
</script>
